export default {
  activities: [],
  selectedActivity: null
}
